/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index number-format to autogenerate all the components and extensions
 * Used by "prepareNumberFormats"
 */

import NumberFormat from './number-format/NumberFormat'
export * from './number-format/NumberFormat'
export default NumberFormat
